import React from 'react';
import Formsy from 'formsy-react';
import { type IModel, type IResetModel, type IUpdateInputsWithError } from 'formsy-react/dist/interfaces';

interface FormProps {
	className?: string;
	id?: string;
	children: React.ReactNode;
	onSubmit?: VoidFunction;
}

const Form = React.forwardRef<Formsy, FormProps>(({ className, id, children, onSubmit }, ref) => {
	function handleKeyDown(event: React.KeyboardEvent<HTMLFormElement>) {
		if (event.key === 'Enter') {
			event.preventDefault();
		}
	}

	function handleValidSubmit(
		_model: IModel,
		_resetModel: IResetModel,
		_updateInputsWithError: IUpdateInputsWithError,
		event: React.SyntheticEvent<HTMLFormElement>
	) {
		event.stopPropagation();
		if (onSubmit) onSubmit();
	}

	function handleInvalidSubmit(
		_model: IModel,
		_resetModel: IResetModel,
		_updateInputsWithError: IUpdateInputsWithError,
		event: React.SyntheticEvent<HTMLFormElement>
	) {
		event.stopPropagation();
	}

	return (
		<Formsy
			id={id}
			ref={ref}
			className={className}
			noValidate
			onKeyDown={handleKeyDown}
			onValidSubmit={handleValidSubmit}
			onInvalidSubmit={handleInvalidSubmit}
		>
			{children}
		</Formsy>
	);
});

export default Form;
